import { combineReducers, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { keyById } from '@mews/fp';

import { AvailabilityBlock, AvailabilityBlocks } from './types';

const dataInitialState: AvailabilityBlocks['data'] = {};

const metaInitialState: AvailabilityBlocks['meta'] = {
    hasFailed: false,
    isFetching: false,
};

interface SetAvailabilityBlocksResponse {
    availabilityBlocks: Array<AvailabilityBlock>;
}

const availabilityBlocksDataSlice = createSlice({
    name: 'availabilityBlocksData',
    initialState: dataInitialState,
    reducers: {
        setAvailabilityBlocks: (
            state,
            { payload: { availabilityBlocks } }: PayloadAction<SetAvailabilityBlocksResponse>
        ) => ({
            ...state,
            ...keyById(availabilityBlocks),
        }),
    },
});

const availabilityBlocksMetaSlice = createSlice({
    name: 'availabilityBlocksMeta',
    initialState: metaInitialState,
    reducers: {
        fetchAvailabilityBlocksStarted: (state) => ({ ...state, isFetching: true, hasFailed: false }),
        fetchAvailabilityBlocksSucceeded: (state) => ({ ...state, isFetching: false, hasFailed: false }),
        fetchAvailabilityBlocksFailed: (state) => ({ ...state, isFetching: false, hasFailed: true }),
    },
});

export const availabilityBlocksReducer = combineReducers({
    data: availabilityBlocksDataSlice.reducer,
    meta: availabilityBlocksMetaSlice.reducer,
});

const { setAvailabilityBlocks } = availabilityBlocksDataSlice.actions;
const { fetchAvailabilityBlocksStarted, fetchAvailabilityBlocksSucceeded, fetchAvailabilityBlocksFailed } =
    availabilityBlocksMetaSlice.actions;

export {
    fetchAvailabilityBlocksStarted,
    fetchAvailabilityBlocksSucceeded,
    fetchAvailabilityBlocksFailed,
    setAvailabilityBlocks,
};
